import { render, staticRenderFns } from "./PackagingTypesCreate.vue?vue&type=template&id=4561f628&scoped=true"
import script from "./PackagingTypesCreate.vue?vue&type=script&lang=js"
export * from "./PackagingTypesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561f628",
  null
  
)

export default component.exports